<!-- Polaris (fase 5.5): the head of the companies list, the contacts list's (fase 5.1, the kit's PageHeader shape):
     title with the count in a Badge, search in the kit's InputGroup (the page debounces 300 ms, as today), the sort
     menu, and "New company" as the kit's primary button (it was the only item of a "⋮" menu). The form stays the
     woot's dialog: three fields are a short form (D-G6). -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useNumberFormatter } from 'shared/composables/useNumberFormatter';
import { Add16, Search16 } from '@carbon/icons-vue';
import { Badge } from 'dashboard/components-next/polaris/ui/badge';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from 'dashboard/components-next/polaris/ui/input-group';
import CompanySortMenu from './components/CompanySortMenu.vue';

defineProps({
  showSearch: { type: Boolean, default: true },
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  count: { type: Number, default: null },
  activeSort: { type: String, default: 'last_activity_at' },
  activeOrdering: { type: String, default: '' },
});

const emit = defineEmits(['search', 'update:sort', 'create']);

const { t } = useI18n();
// The viewer's locale (pt_BR → pt-BR); vue-i18n's n() hands 'pt_BR' to Intl and throws.
const { formatFullNumber: n } = useNumberFormatter();
</script>

<template>
  <header
    class="relative z-20 flex min-h-16 shrink-0 flex-wrap items-center gap-x-3 gap-y-2 border-0 border-b border-solid border-polaris-border px-6 py-3"
  >
    <div class="flex min-w-0 flex-1 basis-40 items-center gap-2">
      <h1
        class="min-w-0 truncate type-polaris-page-title text-polaris-foreground"
      >
        {{ headerTitle }}
      </h1>
      <Badge
        v-if="count"
        variant="secondary"
        class="shrink-0"
        data-companies-count
      >
        {{ n(count) }}
      </Badge>
    </div>
    <div class="flex min-w-0 flex-wrap items-center gap-2">
      <InputGroup v-if="showSearch" class="h-8 w-full sm:w-56">
        <InputGroupInput
          :model-value="searchValue"
          type="search"
          :aria-label="t('COMPANIES_POLARIS.LIST.SEARCH_LABEL')"
          :placeholder="t('COMPANIES.SEARCH_PLACEHOLDER')"
          @update:model-value="value => emit('search', value)"
        />
        <InputGroupAddon><Search16 aria-hidden="true" /></InputGroupAddon>
      </InputGroup>
      <CompanySortMenu
        :active-sort="activeSort"
        :active-ordering="activeOrdering"
        @update:sort="emit('update:sort', $event)"
      />
      <Button size="sm" data-companies-new @click="emit('create')">
        <Add16 aria-hidden="true" />
        {{ t('COMPANIES.ACTIONS.CREATE') }}
      </Button>
    </div>
  </header>
</template>
